import { cls } from "@wss/cls";
import React from "react";
import { BreadcrumbLayoutItem } from "~/common/Store/models/Category";
import { Icon } from "@clarkinc/zest-design-system/ui";
import spritePath from "~/common/Icons/Zest/remixicon.symbol.v1.svg";

const generateBreadcrumbSchema = (breadcrumbs: BreadcrumbLayoutItem[]) => {
  const url = "https://www.webstaurantstore.com";
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: breadcrumbs.map((breadcrumb, index) => ({
      position: index + 1,
      "@type": "ListItem",
      item: url + breadcrumb.link,
      name: breadcrumb.displayText,
    })),
  };
};

export default function Breadcrumbs({
  breadcrumbs,
  navClassName,
  olClassName,
  liClassName,
  textAndIconClassName,
  lastIsLink = false,
  showIcon = false,
}: {
  readonly breadcrumbs: BreadcrumbLayoutItem[];
  readonly navClassName?: string;
  readonly olClassName?: string;
  readonly liClassName?: string;
  readonly textAndIconClassName?: string;
  readonly lastIsLink?: boolean;
  readonly showIcon?: boolean;
}) {
  const filteredBreadcrumbs = breadcrumbs.filter(
    (item) => !["Eligible", "Quick Shipping"].includes(item.displayText),
  );
  return (
    <nav
      aria-label="breadcrumbs"
      className={cls("container global-breadcrumb", navClassName)}
    >
      <ol className={cls("breadcrumb", olClassName)}>
        {filteredBreadcrumbs.map((item, index) => {
          const isLast = index === filteredBreadcrumbs.length - 1;
          if (isLast && lastIsLink) {
            return (
              <li key={item.displayText} className={liClassName}>
                <a
                  className={textAndIconClassName}
                  href={item.link}
                  aria-current="page"
                >
                  {showIcon ? (
                    <Icon
                      name="ri-arrow-left-s-line"
                      className="fill-white h-3 w-3"
                      spriteSheetHref={spritePath}
                    />
                  ) : null}
                  <span className="sr-only">Current: </span>
                  {item.displayText}
                </a>
              </li>
            );
          }

          if (isLast) {
            return (
              <li key={item.displayText}>
                <span aria-current="page">
                  <span className={textAndIconClassName}>
                    <span className="sr-only">Current: </span>
                    {item.displayText}
                  </span>
                </span>
              </li>
            );
          }

          return (
            <li key={item.displayText}>
              <a className={textAndIconClassName} href={item.link}>
                <span>{item.displayText}</span>
              </a>
              <i
                className={cls("icon-breadcrumb", textAndIconClassName)}
                aria-hidden="true"
              />
            </li>
          );
        })}
      </ol>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(generateBreadcrumbSchema(filteredBreadcrumbs)),
        }}
      />
    </nav>
  );
}
